import { SingleCallAsync } from "./SingleCallAsync";

export class SenderWithQueue<T> {
  public toBeSent: T[];
  public singleSend: SingleCallAsync;

  constructor(private onSend: (item: T[]) => Promise<void>) {
    this.toBeSent = [];
    this.singleSend = new SingleCallAsync(async () => {
      return this.sendOne();
    });
  }

  private async sendOne() {
    const { toBeSent } = this;
    if (!toBeSent.length) return;
    const sending = [...toBeSent];
    await this.onSend(sending);
    this.toBeSent = this.toBeSent.filter(
      (item) => sending.indexOf(item) === -1
    );
  }

  send(item: T) {
    this.toBeSent.push(item);
    this.triggerSend();
  }
  private async triggerSend() {
    await this.singleSend.call();
    if (this.toBeSent.length) {
      setTimeout(() => {
        this.triggerSend();
      }, 0);
    }
  }
}
